import { getAgeInputQuizTemplate } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";
import { parseToHtml } from "@/utility/parseToHtml";
import { AGE_INPUT_EVENT_TYPES } from "@/constant";

const decodeFromQuizData = element => {
  if (!element) {
    return {};
  }

  return JSON.parse(decodeURIComponent(unescape(window.atob(element))));
};

const editAgeInputQuizConfig = (editor, shortcodeWrapper) => {
  let currentData = decodeFromQuizData(shortcodeWrapper.getAttribute("data-age-input-data"));
  let isValid = null;

  const ageInputQuizWindow = editor.windowManager.openUrl({
    title: "Age Quiz",
    url: "/age-input-quiz-dialog",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance) {
      if (!isValid || !currentData) {
        ageInputQuizWindow.sendMessage({
          type: AGE_INPUT_EVENT_TYPES.NEED_VALIDATION,
          data: true,
        });

        return;
      }

      editor.windowManager.alert("Success!");
      shortcodeWrapper.setAttribute(
        "data-age-input-data",
        window.btoa(escape(encodeURIComponent(JSON.stringify(currentData)))),
      );
      editor.fire("change");
      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === AGE_INPUT_EVENT_TYPES.REQUEST_DATA) {
        sendData();
      }

      if (message.mceAction === AGE_INPUT_EVENT_TYPES.UPDATE_AGE_INPUT_DATA && message.data) {
        currentData = message.data;
        isValid = true;
      }

      if (message.mceAction === AGE_INPUT_EVENT_TYPES.VALIDATION) {
        isValid = message.data.isValid;
      }
    },
    width: 600,
    height: 600,
  });

  const sendData = () => {
    let existData = decodeFromQuizData(shortcodeWrapper.getAttribute("data-age-input-data"));
    ageInputQuizWindow.sendMessage({
      type: AGE_INPUT_EVENT_TYPES.SEND_DATA,
      data: existData,
    });
  };
};

const ageInputQuizConfig = (tinymce, uuid, shortcodeOnClick) => {
  let currentData = null;
  let isValid = null;

  const ageInputQuizWindow = tinymce.activeEditor.windowManager.openUrl({
    title: "Age Quiz",
    url: "/age-input-quiz-dialog",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance) {
      if (!isValid || !currentData) {
        ageInputQuizWindow.sendMessage({
          type: AGE_INPUT_EVENT_TYPES.NEED_VALIDATION,
          data: true,
        });

        return;
      }
      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, getAgeInputQuizTemplate(), "age-input-quiz");

      const shortcodeWrapperEl = parseToHtml(shortcodeWrapper).querySelector(".shortcode");
      shortcodeWrapperEl.setAttribute(
        "data-age-input-data",
        window.btoa(escape(encodeURIComponent(JSON.stringify(currentData)))),
      );
      addShortcodeToEditor(shortcodeWrapperEl.outerHTML, uuid);

      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === AGE_INPUT_EVENT_TYPES.UPDATE_AGE_INPUT_DATA) {
        currentData = message.data;
        isValid = true;
      }

      if (message.mceAction === AGE_INPUT_EVENT_TYPES.VALIDATION) {
        isValid = message.data.isValid;
      }
    },
    width: 600,
    height: 600,
  });
};

export { ageInputQuizConfig, editAgeInputQuizConfig };
